import React, { useEffect, useRef } from "react";

const PostSavedMessage = (props) => {
  const [isPostSavedMessageVisible, setIsPostSavedMessageVisible] = React.useState(true);

  const postSavedFadeTimerRef = useRef(null);
  const postSavedHideTimerRef = useRef(null);

  useEffect(() => {
    console.log('PostSavedMessage useEffect, props:', props);

    if (postSavedFadeTimerRef.current) {
      clearTimeout(postSavedFadeTimerRef.current);
    }

    if (postSavedHideTimerRef.current) {
      clearTimeout(postSavedHideTimerRef.current);
    }

    postSavedFadeTimerRef.current = setTimeout(() => {
      setIsPostSavedMessageVisible(false);

    }, 2000);

    postSavedHideTimerRef.current = setTimeout(() => {
      props.destroyMessage();
    }, 3000);
  }, []);

  return (
    <div className={`max-w-full px-4 fixed top-4 left-1/2 -translate-x-1/2 x-translate-y-1/2 transition-opacity duration-1000 ${isPostSavedMessageVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="rounded-full shadow-lg">
        <div className="bg-white rounded-full shadow-md px-16 py-4 text-center border border-cirGreyBox">
          <h2 className="font-sharpgrotesk font-semibold text-lg leading-tight">{props.title}</h2>
          <p className="text-base !mb-0">is succesvol opgeslagen.</p>
        </div>
      </div>
    </div>
  );
};

export default PostSavedMessage;
